module.exports = __webpack_public_path__ + "cba861672897235ae0841b52ae6ec13d.pdf";